import { render, staticRenderFns } from "./PresentationKebabMenu.vue?vue&type=template&id=de95bbf0&scoped=true"
import script from "./PresentationKebabMenu.vue?vue&type=script&lang=js"
export * from "./PresentationKebabMenu.vue?vue&type=script&lang=js"
import style0 from "./PresentationKebabMenu.vue?vue&type=style&index=0&id=de95bbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de95bbf0",
  null
  
)

export default component.exports